export default "__VITE_ASSET__Cgaza28W__"